export const contentKey = (type: string, version?: string | null) =>
  !!version ? `${type}_${version}` : type
